import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getStockAnalysis,
  getAllStockAnalysis,
  getNext,
  getPrevious,
  getPageStockAnalysis,
  handleSearch,
} from "./thunk";

const initialState = {
  stockAnalyses: [],
  count: null,
  next: null,
  previous: null,
  loadingNext: false,
  loadingStockAnalysis: false,
};

export const stockAnalysisSlice = createSlice({
  name: "stockAnalysis",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNext.pending, (state) => {
      state.loadingNext = true;
    });
    builder.addCase(getNext.fulfilled, (state, action) => {
      state.loadingNext = false;
      state.next = action.payload.next;
      state.stockAnalyses = [...state.stockAnalyses, ...action.payload.results];
    });
    builder.addCase(getNext.rejected, (state) => {
      state.loadingNext = false;
    });
    builder.addMatcher(isAnyOf(getStockAnalysis.pending, handleSearch.pending), (state) => {
      state.loadingStockAnalysis = true;
    });
    builder.addMatcher(isAnyOf(getStockAnalysis.fulfilled, handleSearch.fulfilled), (state, action) => {
      state.loadingStockAnalysis = false;
      state.stockAnalyses = action.payload.results;
      state.count = action.payload.count;
      state.previous = action.payload.previous;
      state.next = action.payload.next;
    });
    builder.addMatcher(isAnyOf(getStockAnalysis.rejected, handleSearch.rejected), (state) => {
      state.loadingStockAnalysis = false;
    });
  },
});

export const {} = stockAnalysisSlice.actions;

export default stockAnalysisSlice.reducer;
